import { notification } from 'antd';
import { NotificationSettings, defaultSettings } from '../store/notificationStore';

export function showSuccessMessage(options: NotificationSettings) {
  notification.success({
    ...defaultSettings,
    ...options,
  });
}
